import { render } from "./LightningChart.vue?vue&type=template&id=35f4076e"
import script from "./LightningChart.vue?vue&type=script&lang=js"
export * from "./LightningChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__